import { render } from "./jira-dashboard-config.vue?vue&type=template&id=59b3b5d4&scoped=true"
import script from "./jira-dashboard-config.vue?vue&type=script&lang=js"
export * from "./jira-dashboard-config.vue?vue&type=script&lang=js"

import "./jira-dashboard-config.vue?vue&type=style&index=0&id=59b3b5d4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59b3b5d4"]])

export default __exports__